import {svgIconWrapper} from '../svg-icon-wrapper';

import CircleExSolid from './circle-ex-solid-icon.svg';

function SvgComponent(props: React.SVGProps<SVGSVGElement>) {
    return <CircleExSolid {...props} />;
}
SvgComponent.iconName = 'circleExSolid';

export const CircleExSolidIcon = svgIconWrapper(SvgComponent);
